import React from 'react';

export const BrandMark = ({ size = 32, withWord = true, tone = 'onyx' }) => {
  const wordColor = tone === 'onyx' ? 'text-foreground' : 'text-background';
  return (
    <div className="flex items-center gap-2.5 select-none">
      <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <defs>
          <linearGradient id="goldG" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
            <stop stopColor="hsl(45 70% 60%)" />
            <stop offset="1" stopColor="hsl(35 60% 38%)" />
          </linearGradient>
        </defs>
        <rect x="2" y="2" width="44" height="44" rx="10" fill="hsl(220 25% 9%)" />
        <path d="M12 30 C16 18, 24 18, 24 24 S 32 30, 36 18" stroke="url(#goldG)" strokeWidth="2.6" strokeLinecap="round" fill="none" />
        <circle cx="12" cy="30" r="2.4" fill="url(#goldG)" />
        <circle cx="36" cy="18" r="2.4" fill="url(#goldG)" />
        <circle cx="24" cy="24" r="1.8" fill="hsl(45 80% 80%)" />
      </svg>
      {withWord && (
        <div className={`flex flex-col leading-none ${wordColor}`}>
          <span className="text-[13px] font-semibold tracking-[0.18em]">ALWASL</span>
          <span className="text-[10px] font-medium tracking-[0.22em] gold-text">RECOVERY OS</span>
        </div>
      )}
    </div>
  );
};

export default BrandMark;
